// extracted by mini-css-extract-plugin
module.exports = {"header":"ShipmentList_header__Tf-Ys","title":"ShipmentList_title__1B2FW","small":"ShipmentList_small__IAzyX","btnContainer":"ShipmentList_btnContainer__34LJJ"};